module.exports = __webpack_public_path__ + "img/optimizar.316295b4.svg";